export default __webpack_public_path__ + "static/greenPhone-25d2d92586b3c17cc0bbada9fa0c4c3b.svg";